import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';
import Button from './Button';

/**
 * Confirmation dialog (destructive). Now a thin wrapper over the shared <Modal>.
 */
const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    icon={AlertTriangle}
    iconClassName="text-amber-500"
    footer={
      <>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="danger" onClick={onConfirm}>Continue</Button>
      </>
    }
  >
    <p className="text-gray-600 leading-relaxed">{message}</p>
  </Modal>
);

export default ConfirmModal;
